module.exports = __webpack_public_path__ + "img/az.b3729e59.svg";